import React from 'react';


import {
    Button,
    Flash,
    Form,
    FormSection,
    FormField,
    Input,
    ColumnLayout,
    Table,
    TablePagination,
    TablePropertyFiltering,
    TableSorting,
    ExpandableSection,
    Spinner, Icon

} from 'AWS-UI-Components-React';

import {
    JSClient,
    Header
} from '../common';
import {ApprovalTable2} from "./approvals_table2";
import {ApprovalTable3} from "./approvals_table3";
import {HeaderCard} from "../cards/header_card";

const filteringOptions = [
    {
        groupValuesLabel: 'InvoiceId Values',
        propertyKey: 'invoiceId',
        propertyLabel: 'Entity Id',
        values: []
    },
    {
        groupValuesLabel: 'Source Values',
        propertyKey: 'source',
        propertyLabel: 'Source',
        values: ['UI', 'Controller', 'DB']
    }
];
const icon = {
    "source": {
        "DB": "lock-private",
        "UI": "view-horizontal",
        "Controller": "settings"
    }
}
export const COLUMN_DEFINITIONS = [{
    id: 'invoiceId',
    header: () => 'Entity Id',
    cell: (item) => item.invoiceId,
    minWidth: '100px',
    allowLineWrap: false
}, {
    id: 'source',
    header: () => 'Source',
    cell: (item) => <span>{item.source} <Icon name={icon['source'][item.source]}></Icon></span>,
    minWidth: '100px',
    allowLineWrap: false
}, {
    id: 'eventTime',
    header: () => 'Event Time (ms)',
    cell: (item) => parseInt(item.eventTime.toString().substring(0, 13)),
    minWidth: '100px',
    allowLineWrap: false
}, {
    id: 'eventTime2',
    header: () => 'Event Time',
    cell: (item) => (new Date(parseInt(item.eventTime.toString().substring(0, 13)))).toLocaleString(),
    minWidth: '100px',
    allowLineWrap: false
}, {
    id: 'operation',
    header: () => 'Operation',
    cell: (item) => item.operation || item.action,
    minWidth: '100px',
    allowLineWrap: false
}, {
    id: 'status',
    header: () => 'Status',
    cell: (item) => item.status || item.newStatus,
    minWidth: '100px',
    allowLineWrap: false
}, {
    id: 'user',
    header: () => 'System/User',
    cell: (item) => item.user || item.pc_created_by,
    minWidth: '100px',
    allowLineWrap: false
}, {
    id: 'anomaly',
    header: () => 'Outlier',
    cell: (item) => <Icon
        name={item.isAnomaly == null ? "status-in-progress" : (item.isAnomaly ? "bug" : "status-positive")}
        variant={item.isAnomaly ? "error" : "success"}></Icon>,
    minWidth: '100px',
    allowLineWrap: false
}];


const Content = (data) => (
    <ApprovalTable3 data={data}/>
);

const HeaderContent = (data, invoiceId) => (
    <HeaderCard {...data}/>
)

export class ApprovalTable extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            unknownloaderror: false,
            initialLoadDone: false,
            user: "",
            approvalLoadDone: false,
            approvals: [],
            addBeerOpen: false,
            props: JSON.parse(JSON.stringify(this.props))
        };
        this.clientLoaded = this.clientLoaded.bind(this);
        this.showAddModal = this.showAddModal.bind(this);
        this.hideAddModal = this.hideAddModal.bind(this);
        this.getApprovalsResultHandler = this.getApprovalsResultHandler.bind(this);
        this.handleFilteringInput = this.handleFilteringInput.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(filter, {detail}) {
        this.state[filter] = detail.value;
        // this.setState(this.state);
        this.client.getApprovals({
            invoiceId: this.state.invoiceId,
            source: this.state.source,
            ...this.props
        }, this.getApprovalsResultHandler);
    }

    clientLoaded() {
        this.client.getIdentity(identityResult => {
            this.setState({...this.state, user: identityResult.username, initialLoadDone: true});
            // this.client.getApprovals({
            //     type: this.state.type,
            //     user: this.state.user, ...this.props
            // }, this.getApprovalsResultHandler);
        });
    }

    componentWillMount() {
        this.client = new JSClient({onReady: this.clientLoaded});
    }

    // componentWillReceiveProps(nextProps, nextContext) {
    //     if (!objectCompare(this.state.props, nextProps)) {
    //         this.setState({...this.state, props: JSON.parse(JSON.stringify(nextProps)), taskLoadDone: false});
    //     }
    // }

    // componentWillUpdate(nextProps, nextState, nextContext) {
    //     if (!nextState.taskLoadDone)
    //         this.client.getApprovals({
    //         type: nextState.type,
    //         user: nextState.user, ...nextProps
    //     }, this.getTasksResultHandler);
    // }

    getApprovalsResultHandler(approvalResult) {
        let invoices = approvalResult.approvals;
        invoices.sort(function (a, b) {
            return a.eventTime - b.eventTime;
        });

        var reformattedInvoices = invoices.map((obj, index, arr) => {
            obj['eventTime'] = parseInt(obj.eventTime.toString().substring(0, 13));
            return obj;
        });


        let groupedEvents = groupBy(reformattedInvoices, 'eventId')
        let isAnomalousEventMap = {}
        let anomalyReasonEventMap = {}
        Object.keys(groupedEvents).forEach(eventId => {
            isAnomalousEventMap[eventId] = false;
            anomalyReasonEventMap[eventId] = "";

            groupedEvents[eventId].forEach(event => {
                isAnomalousEventMap[eventId] = isAnomalousEventMap[eventId] || event.isAnomaly;
                if (isAnomalousEventMap[eventId]){
                    if(anomalyReasonEventMap[eventId] == "")
                        anomalyReasonEventMap[eventId] += `${event.anomalyReason}`;
                    else
                        anomalyReasonEventMap[eventId] += `, ${event.anomalyReason}`;
                }

            })
            if (!isAnomalousEventMap[eventId]) {
                anomalyReasonEventMap[eventId] = "No outliers were found for this flow.";
            }
        })
        console.log(groupedEvents);
        this.setState({
            approvals: groupBy(reformattedInvoices, 'eventId'),
            approvalLoadDone: true,
            isAnomalousEventMap,
            anomalyReasonEventMap
        });
    }

    headerCounter(items) {
        return items.length;
    }

    showAddModal() {
        this.setState({addBeerOpen: true});
    }

    hideAddModal() {
        this.setState({addBeerOpen: false});
    }

    handleFilteringInput(e) {
        console.log(e);
    }

    renderExpandableSection(events) {
        let eventIds = Object.keys(events);
        let {invoiceId, isAnomalousEventMap,anomalyReasonEventMap} = this.state;
        console.log(this.state.isAnomalousEventMap);
        // {event == "null" ? "Event Id: Not Available" : "Event Id: "+event}
        let elements = eventIds.map((event, key) => {
            return (
                <ExpandableSection
                    header={<HeaderContent
                        data={[{eventId: event, invoiceId: invoiceId, isAnomaly: isAnomalousEventMap[event], anomalyReason: anomalyReasonEventMap[event]}]}/>}
                    content={<Content data={events[event]}/>}
                    variant="container"
                    key={key}
                />)
        });
        return (<div
        >
            <div className="awsui-util-container-header">
                <h2>{eventIds.length} Flow{eventIds.length > 1 ? "s" : ""} found.</h2>
                <div className="awsui-util-container-header-description">
                </div>
            </div>
            {elements}</div>)

    }

    render() {
        if (!this.state.initialLoadDone) {
            return (<div className='offset-xxs-1 col-s-8 offset-l-2 col-xl-3'><Spinner/></div>)
        }
        return (
            <div>
                <div className="awsui-util-container">
                    <div className="awsui-util-container-header">
                        <h2>Flows</h2>
                        <div className="awsui-util-container-header-description">
                        </div>
                    </div>
                    <div>
                        <ColumnLayout columns={2} borders="all">
                            <div data-awsui-column-layout-root="true">
                                <FormField label="Entity Id" description="Eg. 66453606444, 66453606127, etc.">
                                    <Input placeholder="Enter Entity Id"
                                           onChange={this.handleInputChange.bind(this, 'invoiceId')}/>
                                </FormField>
                                <FormField label="Source" description="Eg. UI, Controller, DB, etc.">
                                    <Input placeholder="Enter source"
                                           onChange={this.handleInputChange.bind(this, 'source')}/>
                                </FormField>
                            </div>
                        </ColumnLayout>
                        <br/>
                        {this.renderExpandableSection(this.state.approvals)}
                    </div>
                    <div className="awsui-util-container-footer"></div>
                </div>
            </div>
        );
    }
}

function objectCompare(a, b) {
    return JSON.stringify(a) === JSON.stringify(b)
}

function groupBy(xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};



// WEBPACK FOOTER //
// ./src/components/tables/approvals_table.jsx